<template>
  <!--  START : Work Information -->
  <WCForm
    :form="$v.form"
    @update:value="updateWorkInfo"
    @update:valid="$emit('formUpdateValid', $event, 'profileWorkSection')"
    class="w-100"
  >
    <h3>{{ $t('profileWorkSection') }}</h3>
    <!-- Work Information - company -->
    <WCFormGroup class="wc-input" :field="$v.form.company" v-if="me.company">
      <WCLabel for="account-form__company">{{ $t('company') }}</WCLabel>
      <WCInput class="bg-light form-input" id="account-form__company" autocomplete="organization" />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Work Information - title -->
    <WCFormGroup class="wc-input" :field="$v.form.title" v-if="me.title">
      <WCLabel for="account-form__title">{{ $t('title') }}</WCLabel>
      <WCInput
        class="bg-light form-input"
        id="account-form__title"
        autocomplete="organization-title"
      />
      <WCValidationErrors />
    </WCFormGroup>
  </WCForm>
  <!--  END : Work Information -->
</template>

<script>
/* eslint-disable func-names */

import { maxLength, required } from 'vuelidate/lib/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCForm from '@/modules/forms/components/WCForm/WCForm.vue';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import { ACCOUNT_SETTINGS_OPTIONS } from '@/constants/AppConstants';

export default {
  name: 'WCWorkInfoSectionForm',
  components: {
    WCFormGroup,
    WCLabel,
    WCInput,
    WCForm,
    WCValidationErrors,
  },
  emits: ['formUpdateValid', 'formChanged'],

  props: {
    me: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        company: this.me.company && this.me.company.value,
        title: this.me.title && this.me.title.value,
      },
    };
  },
  validations() {
    const requiredString = {
      required,
      maxLength: maxLength(25),
    };
    return {
      form: {
        company:
          this.me.company && this.me.company.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? requiredString
            : { maxLength: maxLength(25) },
        title:
          this.me.title && this.me.title.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? requiredString
            : { maxLength: maxLength(25) },
      },
    };
  },
  mounted() {
    this.formUpdateValidCheck();
  },
  methods: {
    /**
     * Method to emit validity of form fields
     */
    formUpdateValidCheck() {
      this.$emit('formUpdateValid', !this.$v.$invalid, 'profileWorkSection');
    },
    /**
     * Method to emit work info form data if valid
     */
    updateWorkInfo() {
      if (!this.$v.$invalid) {
        this.$emit('formChanged', this.form);
      }
    },
  },
};
</script>
